import type { IconProps } from './types';

function BookSharpIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M12 7.3125C12 5.24143 10.321 3.5625 8.25 3.5625H1.6875V18.5625H9.1875C10.7408 18.5625 12 19.8217 12 21.375M12 7.3125V21.375M12 7.3125C12 5.24143 13.679 3.5625 15.75 3.5625H22.3125V18.5625H14.8125C13.2592 18.5625 12 19.8217 12 21.375"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { BookSharpIcon };
